import ThreeDSecure from './threeDSecure';

export default ThreeDSecure;
